import React, { useState, useContext } from "react";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import { forgotPassword } from "../../../utils/API/forgotPassword";
import { TopLoaderContext } from "../../../context/TopLoader";
import { ReactComponent as Mail } from "../../svgs/mail.svg";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";

const PasswordRecoveryForm = ({ userType }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const { loadingRef } = useContext(TopLoaderContext);

  const onEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      loadingRef.current.continuousStart();
      await forgotPassword({ email, userType }, dispatch);
      loadingRef.current.complete();
      toast.success("Link has been sent!");
      setEmail("");
    } catch (err) {
      loadingRef.current.complete();
      toast.error(err.message);
    }
  };

  return (
    <form
      className="w-full flex flex-col gap-y-6 mt-16"
      onSubmit={onSubmitHandler}
    >
      <Input
        label="Email"
        type="email"
        className="w-full"
        Icon={Mail}
        onChange={onEmailChange}
        value={email}
        required={true}
      />
      <Button
        type="submit"
        color="blue"
        varient="rounded"
        className="w-fit py-2 px-16 mx-auto text-2xl tracking-widest text-white mt-12"
      >
        Recover
      </Button>
    </form>
  );
};

export default PasswordRecoveryForm;
